import axios from "./axiosInstance";
import config from "./config";
import { captureException } from "../utils/sentry";

const BASE_URL = config.BASE_URL;

export const getAllRoles = async (token) => {
  return axios
    .get(`${BASE_URL}/role-permission/roles`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      captureException(err);
      throw err;
    });
};

export const addNewRole = async (token, formData) => {
  return axios
    .post(`${BASE_URL}/role-permission/roles`, formData, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      captureException(err);
      throw err;
    });
};

export const getRolesWithPermissions = async (token) => {
  return axios
    .get(`${BASE_URL}/role-permission/roles-with-permissions`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      captureException(err);
      throw err;
    });
};
export const getAllPermissions = async (token) => {
  return axios
    .get(`${BASE_URL}/role-permission/permissions`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      captureException(err);
      throw err;
    });
};

export const getRolePermissions = async (token, roleId) => {
  return axios
    .get(`${BASE_URL}/role-permission/roles/${roleId}/permissions`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return { success: false, data: [], message: err?.response?.data?.error || err.message || "Failed to fetch role permissions" };
    });
};

export const updateRolePermissions = async (token, roleId, permissionIds) => {
  return axios
    .post(
      `${BASE_URL}/role-permission/roles/${roleId}/permissions`,
      { permission_ids: permissionIds },
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return { success: false, message: err?.response?.data?.error || err.message || "Failed to update permissions" };
    });
};

// NOTE: addNewPermission / deletePermission were removed along with their
// backend endpoints. The permission catalog is code-defined (backend
// src/config/permissionCatalog.js + seeding migrations); the UI manages
// roles and grants only.

// Old signature: deleteRole(token, id)
// New signature: deleteRole(token, id, reassignToRoleId?)
//
// When the role has assigned users, the backend returns 409 with the
// impact payload. Pass `reassignToRoleId` to bulk-reassign those users
// to another role before delete.
export const deleteRole = (token, id, reassignToRoleId) => {
  return axios
    .delete(`${BASE_URL}/role-permission/roles/${id}`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      ...(reassignToRoleId
        ? { data: { reassign_to_role_id: reassignToRoleId } }
        : {}),
    })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data || { success: false });
};

// GET impact preview before deleting a role
export const getRoleDeleteImpact = (token, id) => {
  return axios
    .get(`${BASE_URL}/role-permission/roles/${id}/delete-impact`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res?.data)
    .catch((err) => err?.response?.data || { success: false });
};
